import React from 'react';
import { useTranslation } from 'react-i18next';
import NotificationDialogV4 from '@src/components/NotificationDialogV4';
import { Button } from '@mui/material';
import WaringImg from '@src/assets/images/warning.png';
import { delimitNumber } from '@src/utils/number';

const PaidMaxCharsLimitExceeded = ({ open, onClose, maxLengthInputText }) => {
  const { i18n } = useTranslation();
  const { t, language } = i18n;

  const renderActionButton = () => (
    <Button variant="contained" onClick={onClose}>
      {t('understood')}
    </Button>
  );
  return (
    <NotificationDialogV4
      image={WaringImg}
      title={t('maxCharsLimitExceeded')}
      description={t('paidMaxCharsLimitExceededDesc', {
        maxLengthInputText: delimitNumber(maxLengthInputText, language),
      })}
      actionComponent={renderActionButton()}
      open={open}
      onClose={onClose}
    />
  );
};

export default PaidMaxCharsLimitExceeded;
